(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerAppointment',
	};

	var form_id = 'liveplannerappointment-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var scheduled           = $.parseJSON($('#liveplannerappointment-schedule').val());
		var agent_changed_title = false;

		Adzuki.CharacterCount('#liveplannerappointment-client_notes', {
			max  : 255,
			label: '#client-notes-count',
		});

		Adzuki.CharacterCount('#liveplannerappointment-agent_notes', {
			max  : 255,
			label: '#agent-notes-count',
		});

		// when changing the date of the appointment, display the schedule for that day
		$('#' + form_id + 'date').on('dp.change', function _dateSet(event) {
			var appointment_date = event.date,
				day_of_week      = moment(appointment_date).format("ddd").toLowerCase(),
				allowed          = false;

			$.each(scheduled, function _iterateOverSchedule(index, element) {
				if (index === day_of_week) {
					allowed = true;
					return false;
				}
			});

			if (allowed === true) {
				Adzuki.Ajax.get(Adzuki.base_uri + '/LivePlanner/appointmentsByDate/' + moment(appointment_date).format("YYYY-MM-DD"))
				.then(function success(response) {
					$('.lp-appointment-availability').html(response);
				});
			} else {
				Adzuki.Ajax.get(Adzuki.base_uri + '/LivePlanner/appointmentsByDate/' + moment(appointment_date).format("YYYY-MM-DD"))
				.then(function success(response) {
					$('.lp-appointment-availability').html('<div class="alert alert-info">' + moment(appointment_date).format("dddd") + ' is not set to allow for LivePlanner appointments. However, you are free to schedule on this day.</div>' + response);
				});
			}
		});

		$('#' + form_id + 'neworexistingclient-0-existingclient-existing_client_name')
		.on('ta.set-hidden', function _setHidden(e) {
			var client_id = $('#' + form_id + 'neworexistingclient-0-existingclient-existing_client_id').val();

			Adzuki.Ajax.get(Adzuki.base_uri + '/LivePlanner/clientCheck/' + client_id)
			.then(function success(response) {
				var appointment_title = $('#' + form_id + 'title').val();

				if (response.email.length > 0) {
					$('#' + form_id + 'send_email').prop('disabled', false);
				} else {
					$('#' + form_id + 'send_email').prop('disabled', true);
				}

				if (
					response.full_nickname
					&& (
						!appointment_title ||
						appointment_title === '' ||
						agent_changed_title === false
					)
				) {
					$('#' + form_id + 'title').val(response.full_nickname + '\'s LivePlanner Appointment');
				}
			});
		});

		$('#' + form_id + 'neworexistingclient-0-existingclient-existing_client_name')
		.on('ta.reset', function _reset(e) {
			$('#' + form_id + 'send_email').prop('disabled', true);
		});

		$('#' + form_id + '-neworexistingclient-0-newclient-new_client_email')
		.on('change', function _emailSet() {
			if ($(this).val().length > 0 && Adzuki.String.isEmail($(this).val())) {
				$('#' + form_id + 'send_email').prop('disabled', false);
			} else {
				$('#' + form_id + 'send_email').prop('disabled', true);
			}
		});

		// record if the agent changed the title
		$('#' + form_id + 'title').on('change', function titleChanged(e) {
			agent_changed_title = true;
		});

		// checking/unchecking the checkbox to add additional participants
		$('#' + form_id + 'add_additional_participants').on('change', function onCheckboxChange(e) {
			if ($(this).is(':checked')) {
				$('.additional-participants-selection, .add-new-additional-participant').addClass('in');
			} else {
				$('.additional-participants-selection, .add-new-additional-participant').removeClass('in');
			}
		});

		// if we are editing an existing appointment, don't change the title that is set for it
		// unless the agent actually changes the title of the appointment
		if ($('#' + form_id + 'id').val() !== '') {
			agent_changed_title = true;
		}

		// adding a new additional participant
		$('.add-participant-btn').on('click', function addNewParticipant(e) {
			var $modal         = $('.modal');
			var appointment_id = null;
			var url            = '/LivePlanner/addParticipantToAppointment';

			e.preventDefault();

			if (appointment_id) {
				url += '/' + appointment_id;
			}

			// open modal with the form to create the client
			// once done, add the participant to the recipient search
			// it should be added as client
			Adzuki.Ajax.get(url).then(function viewForm(response) {
				$modal.find('.modal-title').text('Add New Client');
				$modal.find('.modal-body').html(response);
				$modal.modal('show');

				Adzuki.Form.initAjaxForm('LivePlannerParticipant');

				$modal.on('hidden.bs.modal', function modalHidden() {
					$modal.find('.modal-body').html('');
					$modal.off('hidden.bs.modal');
				});
			});
		});

		if ($('.new-client-email').length > 0) {
			$('.new-client-email').on('keyup', function _onKeyupHandler(e) {
				var email = $(this).val();

				if (Adzuki.String.isEmail(email)) {
					$('#' + form_id + 'send_email').prop('disabled', false);
				} else {
					$('#' + form_id + 'send_email').prop('disabled', true);
				}
			});
		}

		$('#' + form_id + 'add_additional_participants').trigger('change');
	};

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);

		if (response.data.response_code === 'zoom_terms') {
			Adzuki.CustomConfirm({
				title  : 'Zoom Terms of Service',
				body   : 'I acknowledge that I have read the <a href="https://explore.zoom.us/en/eula-terms-of-service/" target="_blank">Zoom Terms of Service</a> related to video meeting features available within LivePlanner.',
				confirm: function _acceptTerms() {
					Adzuki.Ajax.get('/LivePlanner/acceptZoomTerms')
					.then(function _acceptZoomTerms(response) {
						if (response.lp_zoom_terms_agreed) {
							$(form.element).submit();
							return;
						}

						Adzuki.StatusMessage('error', 'There was a problem saving the Zoom Terms of Service, please try again.');
					});
				},
				cancel: function _rejectTerms() {
					// do nothing
				}
			});
		}
	};
}(jQuery, window.Adzuki || {}));
